import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

import EmployeeViewList from 'features/Employee';

function EmployeeViewListPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="employee">
            <EmployeeViewList />
          </Can>
          <Can not do="read" on="employee">
            <h4 className="text-red-500">{t('permission.forbid.read.employee')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default EmployeeViewListPage;
